import React, { memo, useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import Tournaments from './Tournaments';
import Matches from './Matches';
import Analyses from './Analyses';
import i18n from '@i18n';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import SearchIcon from '@/icons/SearchIcon';
import { callSearch, SEARCH_RESULT_MATCHES_BOXSTORE, SEARCH_RESULT_TOURNAMENTS_BOXSTORE } from '../services/results';
import { SEARCH_LIVE, SEARCH_PREMATCH, SEARCH_RESULT, SEARCH_TOURNAMENTS } from '@/nikeone/context/BoxOptionsContext';
import useBoxStore from '@/nikeone/hook/useBoxStore';
import useClock from '@/nikeone/hook/useClock';
import { COMMUNITY_ANALYSIS_DETAIL } from '@/routing/routes';
import { navigate } from '@/routing';
import { onFullSearch } from '@/fullsearch/handlers';
import { searchResultData$ } from '@/fullsearch/subs';
import TurboLiveProvider from '@/turbo-live/context/TurboLiveProvider';
import BetLocationContext, { betLocation } from 'nike-ui/src/common/BetLocationContext';

/**
 *  Root path component; params: [searchText]
 */
function FullSearch({ searchText }) {
    useBoxStore(SEARCH_RESULT_TOURNAMENTS_BOXSTORE, SEARCH_TOURNAMENTS);
    useBoxStore(SEARCH_RESULT_MATCHES_BOXSTORE);
    useClock('nikeone.tick');
    useEffect(() => {
        callSearch(searchText).then(searchData => dispatch(onFullSearch(searchData)));
    }, [searchText]);
    const { subscribe } = useReframe();
    const searchData = subscribe(searchResultData$);

    if (!searchData || Object.keys(searchData).length === 0) {
        const stateIcon = <SearchIcon width={50} height={50} />;
        return <EmptyState stateIcon={stateIcon} text={i18n('search.result.empty')} />;
    }

    function onUaItemClick({ id, niceUrl }) {
        navigate(COMMUNITY_ANALYSIS_DETAIL, { postId: id, postUrlSuffix: niceUrl });
    }

    return (
        <div className="page-wrap-search layout-offer-rw">
            <TurboLiveProvider>
                <div className="search-text-display">
                    <h1
                        dangerouslySetInnerHTML={{
                            __html: i18n('search.result.text') + ': &ldquor;' + searchText + '&ldquo;'
                        }}
                    />
                </div>
                <BetLocationContext.Provider value={{ betLocationSection: betLocation.HP_SEARCH }}>
                    <Matches boxOptions={SEARCH_LIVE} text="search.result.type.l" />
                    <Matches boxOptions={SEARCH_PREMATCH} text="search.result.type.m" />
                    <Tournaments items={searchData.T} />
                    <Analyses items={searchData.UA} header={i18n('search.result.type.ua')} onClick={onUaItemClick} />
                    <Matches boxOptions={SEARCH_RESULT} text="search.result.type.r" />
                </BetLocationContext.Provider>
            </TurboLiveProvider>
        </div>
    );
}

export default memo(FullSearch);
